import { render, staticRenderFns } from "./KpiDashboard.vue?vue&type=template&id=f5c34bf0&scoped=true"
import script from "./KpiDashboard.vue?vue&type=script&lang=ts"
export * from "./KpiDashboard.vue?vue&type=script&lang=ts"
import style0 from "./KpiDashboard.vue?vue&type=style&index=0&id=f5c34bf0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5c34bf0",
  null
  
)

export default component.exports